const textFieldFormActions = {
  actionText: 'Acción',
  problemText: 'Problema',
};

export default textFieldFormActions;
